import { render } from "./Rooms.vue?vue&type=template&id=04e4876f&scoped=true&ts=true"
import script from "./Rooms.vue?vue&type=script&lang=ts"
export * from "./Rooms.vue?vue&type=script&lang=ts"

import "./Rooms.vue?vue&type=style&index=0&id=04e4876f&lang=css"
import "./Rooms.vue?vue&type=style&index=1&id=04e4876f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e4876f"]])

export default __exports__